import { PUBLIC_URL } from '../config/env';

const consonants = 'Consonants and Vowels.docx';
const cvc = 'CVC Word Bank.docx';
const blends = 'Consonant Blends Word Bank.docx';
const digraphs = 'Consonant Digraph Word Bank.docx';
const cvce = 'CVCe Word Bank.docx';
const rControlled = 'R-Controlled Word Bank.docx';
const longVowels = 'Long Vowels Word Bank.docx';
const diphthongs = 'Diphthongs Word Bank.docx';
const multisyllabic = 'Multisyllabic Word Bank.docx';
const roots = 'Greek and Latin Roots Word Bank.docx';

const ACTIVITIES_BY_STANDARD: Record<string, string[]> = {
  'K.RF.3.A.a': [consonants],
  'K.RF.3.A.c': [cvc],
  '1.RF.3.A.c': [blends],
  '1.RF.3.A.d': [digraphs],
  '1.RF.3.A.b': [cvce, longVowels],
  '2.RF.3.A.h': [rControlled],
  '2.RF.3.A.a': [longVowels, diphthongs, multisyllabic],
  '3.RF.3.A.a': [multisyllabic],
  '4.RF.3.A.a': [multisyllabic],
  '5.RF.3.A.a': [multisyllabic],
  '4.RF.3.A.b': [roots],
};

export function getActionCardActivities(standard: string | null | undefined) {
  const code = String(standard || '').trim().replace(/\.+$/, '').toLowerCase();
  const key = Object.keys(ACTIVITIES_BY_STANDARD).find((candidate) => candidate.toLowerCase() === code);
  return (key ? ACTIVITIES_BY_STANDARD[key] : []).map((filename) => ({
    filename,
    label: filename.replace(/\.docx$/, ''),
    href: `${PUBLIC_URL}/${encodeURIComponent(filename)}`,
  }));
}
